/** Query-string key carrying the Revenue Analytics provider selection; repeated once per provider. */
export const REVENUE_ANALYTICS_PROVIDER_PARAM = 'providerId';

/** Provider ids from a location `search` string, in URL order, blanks and duplicates dropped. */
export function parseRevenueAnalyticsProviderIds(search: string): string[] {
    return new URLSearchParams(search)
        .getAll(REVENUE_ANALYTICS_PROVIDER_PARAM)
        .values()
        .map((id) => id.trim())
        .filter((id) => id !== '')
        .unique()
        .toArray();
}

/**
 * `search` with the provider selection replaced by `providerIds`, other
 * params untouched. Ids are normalized the same way the parser reads them
 * (trimmed, blanks and duplicates dropped) so the two functions are
 * inverse. Empty when nothing remains, `?`-prefixed otherwise, so it can
 * be handed straight to a navigation target.
 */
export function withRevenueAnalyticsProviderIds(search: string, providerIds: ReadonlyArray<string>): string {
    const params = new URLSearchParams(search);
    params.delete(REVENUE_ANALYTICS_PROVIDER_PARAM);
    const normalized = providerIds
        .values()
        .map((id) => id.trim())
        .filter((id) => id !== '')
        .unique();
    for (const id of normalized) params.append(REVENUE_ANALYTICS_PROVIDER_PARAM, id);
    return params.size === 0 ? '' : `?${params.toString()}`;
}
